var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInProgress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.92 4.253L1.947 5.28A5.34 5.34 0 007 12.333 5.34 5.34 0 0012.333 7 5.34 5.34 0 005.28 1.947L4.26.927A6.63 6.63 0 017 .333 6.67 6.67 0 0113.667 7 6.67 6.67 0 017 13.667 6.67 6.67 0 01.333 7c0-.98.214-1.907.587-2.747zm2.747-1.586c0 .553-.447 1-1 1-.554 0-1-.447-1-1 0-.554.446-1 1-1 .553 0 1 .446 1 1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInProgress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/inProgress.5ec85311a9fbc60bc7685f0b65258d9f.svg";